import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { event_log_api } from '@axo/shared/data-access/api';
import {
  loanApplicationEventsKeys,
  parseLoanApplicationEventsKey,
} from '../cache-keys/loanApplicationEventsKeys';
import { event_log } from '@axo/shared/data-access/types';
import { queryFunction } from '../query-function';

export function useLoanApplicationEvents(
  request: { find: event_log.Find } | { cursor: string }
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = loanApplicationEventsKeys.root({
    find: 'find' in request ? request.find : undefined,
    cursor: 'cursor' in request ? request.cursor : undefined,
  });

  return useQuery(
    cacheKey,
    queryFunction(event_log_api.find(api), ({ queryKey }) => {
      const { find, cursor } = parseLoanApplicationEventsKey(queryKey);
      return find ?? cursor ?? {};
    }),
    {
      enabled: state.user.token.length > 0,
    }
  );
}
